import ENV from 'rise-ui/config/environment.js';
import { utcOffset } from 'rise-ui/utils/date.js';
import { totalPages } from 'rise-ui/utils/pages.js';
import { buildUrl } from 'rise-ui/utils/ajax.js';

const API = ENV.APP.API.DATA;

export function getResultsUrl(queryParams) {
  return buildUrl([ API.URL , API.NAMESPACE , 'result' ], { queryParams });
}

export function getExposedResultsUrl(queryParams) {
  return buildUrl([ API.EXPOSED_URL , API.NAMESPACE , 'result' ], { queryParams });
}

export function pagingFromResponse(response) {
  const { totalItems, itemsPerPage, currentPage } = response && response.meta || {};
  return {
    currentPage: currentPage,
    totalPages: totalPages(totalItems, itemsPerPage),
    totalItems,
    itemsPerPage,
  };
}

export function resultsFromResponse(response, i) {
  const results = [];
  (response && response.data || []).forEach(result => {
    if (!result) {
      return;
    }
    const attrs = result.attributes || {};
    const { dateTime, modelRunMemberId, timezoneOffset } = attrs;
    const id = attrs._id;
    const value = attrs.result;
    if (dateTime) {
      results.push({
        id,
        dateTime: utcOffset(new Date(dateTime)),
        timezoneOffset,
        value,
        modelRunMemberId,
      });
    }
  });
  return results;
}

export function getResultInfo(loader) {
  return {
    url: loader?.getExposedUrl?.(),
    pagedUrl: loader?.getExposedUrl?.(2),
  };
}
